/**
 * Komponenta fulltextového hledání kategorie úřední desky - našeptávač.
 */
import React from 'react';
import AbstractReactComponent from "../AbstractReactComponent";
import SpisovaSluzbaApi from "./../api/gen/spisovaSluzba/SpisovaSluzbaApi";
import ObjectSuggestField from "./ObjectSuggestField";

/**
 * Field pro výběr kategorie úřední desky.
 */
class KategorieUredniDeskyField extends AbstractReactComponent {

    state : {list: ?KategorieUredniDeskyVO[]} = {
        list: null
    };

    componentDidMount() {
        this.setState({list: null});
        SpisovaSluzbaApi.getKategorieUredniDesky().then(list => {
            this.setState({list})
        });
    }

    render() {
        const {list} = this.state;
        const {...otherProps} = this.props;

        return <ObjectSuggestField
            dropdown={true}
            removable={false}
            items={list}
            itemValueAttrName="nazev"
            {...otherProps}
        />
    }
}

export default KategorieUredniDeskyField;
